import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import UsersItemMenu from '@/views/pages/Users/elements/UsersItemMenu';

const UsersItem = ({ data, onEditItem, onDeleteItem, setShowModalDeleteItem, setShowModalAddDepartment }) => {
	const { dict } = useSelector((state) => state.app);

	const getRoleName = (role) => {
		switch (role) {
			case 'editor':
				return dict.roles.editor;
			case 'reader':
				return dict.roles.reader;
			case 'expert':
				return dict.roles.expert;
			case 'admin':
				return dict.roles.admin;
			default:
				break;
		}
	};

	const getDepartmentValue = (departments) => {
		if (departments.length === 0) {
			return '-';
		}

		const firstDepartmentName = departments[0].name;
		const otherDepartmentCount = departments.length - 1;

		if (otherDepartmentCount > 0) {
			return `${firstDepartmentName}, +${otherDepartmentCount}`;
		} else {
			return firstDepartmentName;
		}
	};

	return (
		<div className='table__users__item'>
			<div className='table__users__item--col col-flex'>
				<div className='table__users__item--col-label'>{ dict.users.list.name}:&nbsp;</div>
				{data.displayName}
			</div>

			<div className='table__users__item--col col-flex'>
				<div className='table__users__item--col-label'>{ dict.users.list.email}:&nbsp;</div>
				{data.email}
			</div>
			<div className='table__users__item--col col-flex'>
				<div className='table__users__item--col-label'>{ dict.users.list.department}:&nbsp;</div>
				{getDepartmentValue(data.departments)}
			</div>
			<div className='table__users__item--col col-flex'>
				<div className='table__users__item--col-label'>{ dict.users.list.role}:&nbsp;</div>
				{getRoleName(data.role)}
			</div>
			<div className='table__users__item--col col-flex'>
				<div className='table__users__item--col-label'>{ dict.users.list.account}:&nbsp;</div>
				{data.provider === 'mim' ? dict.users.list.mimAccount : dict.users.list.localAccount}
			</div>
			
			<div
				className='table__users__item--col col-flex'
				style={ { overflow: 'unset' } }
			>
				<UsersItemMenu
					onEditItem={ onEditItem }
					onDeleteItem={ onDeleteItem }
					setShowModalDeleteItem={ setShowModalDeleteItem }
					setShowModalAddDepartment={ setShowModalAddDepartment }
					data={ data }
				/>
			</div>
		</div>
	);
};

export default memo(UsersItem);